var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.DashJS = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (this.isLive) {
      return this.player.timeAsUTC()
    } else {
      return this.player.time()
    }
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.duration()
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    var level = this.player.getQualityFor("video")
    return this.player.getBitrateInfoListFor("video")[level].bitrate
  },

  /** Override to return user bandwidth throughput */
  getThroughput: function () {
    if (this.getCdnTraffic() && this.getCdnTraffic() !== 0) {
      if (!this.lastDataValue) {
        this.lastDataValue = 0
      }
      var prevDataValue = this.lastDataValue
      this.lastDataValue = this.getCdnTraffic() + this.getP2PTraffic()
      return Math.round((this.lastDataValue - prevDataValue) / (this.plugin._ping.interval / 1000))
    }
    if (!this.throughput) {
      var metrics = this.player.getMetricsFor('video')
      var dashMetrics = this.player.getDashMetrics()
      var requests = dashMetrics.getHttpRequests(metrics)
      if (!requests) return null
      var bps = 0
      var bpsCount = 0
      for (var i = 0; i < requests.length; i++) {
        var req = requests[i]
        if (req.type == 'MediaSegment' && req.responsecode >= 200 && req.responsecode < 400 && req._stream == 'video') {
          var match = req._responseHeaders.match(/Content-Length: (.+)/i)
          if (match) {
            var time = (req.interval - (req.tresponse - req.trequest)) / 1000
            bps += (match[1] / time) * 8
            bpsCount++
          }
        }
      }
      if (!bps) return null
      this.throughput = bps / bpsCount
    }
    return this.throughput
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    if (!this.isLive) {
      this.isLive = false
    }
    return this.isLive
  },

  /** Override to return resource URL. */
  getResource: function () {
    var src = this.player.getSource()
    if (typeof src === 'string') {
      return src
    } else {
      return 'Manifest'
    }
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'dashJS'
  },

  getPlayerVersion: function () {
    return this.player.getVersion()
  },

  /** Register listeners to this.player. */
  registerListeners: function () {

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    var Events = dashjs.MediaPlayer.events

    // Register listeners
    this.references = []
    this.references[Events.MANIFEST_LOADED] = this.manifestLoaded.bind(this)
    this.references[Events.PLAYBACK_STARTED] = this.playbackStarted.bind(this)
    this.references[Events.PLAYBACK_RATE_CHANGED] = this.playbackRateChanged.bind(this)
    this.references[Events.PLAYBACK_PLAYING] = this.playbackPlaying.bind(this)
    this.references[Events.PLAYBACK_SEEKED] = this.playbackPlaying.bind(this)
    this.references[Events.PLAYBACK_PAUSED] = this.playbackPaused.bind(this)
    this.references[Events.PLAYBACK_ENDED] = this.playbackEnded.bind(this)
    this.references[Events.ERROR] = this.errorListener.bind(this)
    this.references[Events.PLAYBACK_ERROR] = this.playbackError.bind(this)
    this.references[Events.PLAYBACK_SEEKING] = this.playbackSeeking.bind(this)

    for (var key in this.references) {
      this.player.on(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.off(key, this.references[key])
      }
      this.references = []
    }
  },

  /** Listener for live. */
  manifestLoaded: function (e) {
    this.isLive = (e.data && e.data.type === 'dynamic')
    this.monitor.stop()
    if (!this.Live) {
      this.monitorPlayhead(true, false)
    }
  },

  /** Listener for playback rate. */
  playbackRateChanged: function (e) {
    youbora.Log.debug('playrate x' + e.playbackRate)
    if (e.playbackRate == 1) {
      this.monitor._lastPlayhead = 0
    }
  },

  /** Listener for 'play' event. */
  playbackStarted: function (e) {
    this.fireStart()
  },

  /** Listener for 'pause' event. */
  playbackPaused: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playbackPlaying: function (e) {
    this.fireResume()
    if (!this.player.isPaused()) this.fireSeekEnd()
    this.fireBufferEnd()
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError(e.error + "_error")
  },

  /** Listener for 'error' event. */
  playbackError: function (e) {
    this.fireError(e.error + "_error")
  },

  /** Listener for 'seeking' event. */
  playbackSeeking: function (e) {
    if (!this.getIsLive()) this.fireSeekBegin()
  },

  /** Listener for 'ended' event. */
  playbackEnded: function (e) {
    this.fireStop()
  },

  getCdnTraffic: function () {
    var allMetrics = this.player.getMetricsFor("p2pweb")
    if (!allMetrics) return youbora.Adapter.prototype.getCdnTraffic()
    var metrics = allMetrics.metricsP2PWeb
    return metrics.videoAvgLength * metrics.chunksFromCDN +
      metrics.audioAvgLength * metrics.chunksFromCDN
  },

  getP2PTraffic: function () {
    var allMetrics = this.player.getMetricsFor("p2pweb")
    if (!allMetrics) return youbora.Adapter.prototype.getP2PTraffic()
    var metrics = allMetrics.metricsP2PWeb
    return metrics.videoAvgLength * metrics.chunksFromP2P +
      metrics.audioAvgLength * metrics.chunksFromP2P
  }
})

module.exports = youbora.adapters.DashJS



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 25
// module chunks = 0